<template>
  <div class="container-fluid">
    <div class="row about-back">
      <main id="main" class="site-main main-content">
        <article
          id="post-2295"
          class="post-2295 page type-page status-publish hentry"
        >
          <div class="entry-content">
            <!-- ABOUT US -->
            <div class="hc-about-us">
              <div class="container">
                <div class="row">
                  <div class="col-sm-12 col-md-12">
                    <h2 class="wow fadeIn" style="text-align: center">
                      About Us
                    </h2>
                    <br />
                    <h2 class="wow fadeIn" style="font-size: 30px">
                      The Invention of Robust Eye
                    </h2>
                  </div>
                  <div class="col-sm-12 col-md-4">
                    <div class="wow fadeIn">
                      <p>
                        <span
                          >Personal contents of people, in the form of image,
                          video, audio and text, are stolen or faked by
                          anonymous individuals with the motive of making money
                          or taking revenge or bringing down victim’s
                          fame/social image or simply to blackmail a victim for
                          money or other kinds of favour. On the other hand,
                          businesses are very unfairly targeted today by cyber
                          harassers and hackers via fake/false reviews,
                          usurpation of intellectual properties, infringement of
                          copyrights, impersonation of brands etc. and by
                          business competitors via false reviews. Furthermore,
                          celebrities and VIPs are attacked by cyber harassers
                          inhumanly.</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-8">
                    <div class="hc-about-us-video-img">
                      <div class="mt_video text-center row">
                        <div class="wow fadeIn animated hc-visible">
                          <!-- <a class="popup-vimeo-video" href="https://vimeo.com/56833255"><img class="buton_image_class" src="assets/images/hostcluster-play.png" alt="hostcluster-play"></a> -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12">
                    <div class="wow fadeIn">
                      <br />
                      <p>
                        <span
                          >There are various organizations who provide solutions
                          for these issues and remove contents from cyberspace
                          when customers submit their affected contents, and
                          charge for each and every removal from particular
                          locations, which makes the content removal process
                          very costly.</span
                        >
                      </p>
                      <br />
                      <p>
                        <span
                          >Accepting this as a challenge, a team of experts
                          consists of persons with extraordinary skills started
                          research and development activities in the year 2010,
                          and continuously investigated individual as well as
                          business issues very systematically and innovated a
                          cutting edge solution for the total requirement of
                          cyber victims, both the individual and business.
                        </span>
                      </p>
                    </div>
                    <div class="wow fadeIn">
                      <br />
                      <p>
                        <span
                          >The invention of
                          <b>“Robust Eye Technology” (RET)</b> based on
                          artificial intelligence was our ultimate solution for
                          all the issues with respect to misuse or abuse of
                          cyberspace. The most significant feature of the RET is
                          its ability to search and remove the content not only
                          from one location but from all the locations, when a
                          customer submits the affected content, comparatively
                          at a very low cost. The RET has been identified by
                          many of the subject matter experts as an innovation
                          for the future.</span
                        >
                      </p>
                    </div>
                    <div class="clearfix" />
                    <br />
                    <br />
                    <h2 class="wow fadeIn" style="font-size: 30px">
                      The Formation of “Clear Me Out”
                    </h2>
                    <div class="wow fadeIn">
                      <p>
                        <span
                          >Our next challenge was finding a way to offer the
                          service of RET to customers. We successfully carried
                          forward our research and development activities
                          analyzing requirements of potential customers as well
                          as relevant legal and government regulations till the
                          realization of RET’s content removal process as a
                          service. Finally, we formed our company “Clear Me
                          Out”, a service provider organization in the year 2017
                          with a team of dedicated cybersecurity experts.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- MEET OUR TEAM -->
            <div class="row hc-about-us-meet-team hc-pt">
              <div class="col-sm-12">
                <div class="title-subtile-holder container">
                  <h1 class="section-title dark_title container">Mission</h1>
                  <br />
                  <img src="/static/assets/images/one.png" width="86px" />
                  <div class="section-subtitle dark_subtitle">
                    To provide cutting edge solutions to our customers
                    victimized by cyber harassments, fake/false reviews, brand
                    impersonation, usurpation of intellectual property, or
                    simply by any kind of cyber abuse, meeting their total
                    needs.
                  </div>
                  <img
                    src="/static/assets/images/two.png"
                    width="86px"
                    style="margin-top: 10px"
                    class="f-right"
                  />
                </div>
              </div>
            </div>

            <!-- MOST POPULAR DOMAINS -->
            <div class="clearfix"></div>
            <div class="row hc-about-us-popular hc-pb">
              <div class="col-sm-12">
                <div class="title-subtile-holder container">
                  <h1 class="section-title dark_title container">Vision</h1>
                  <br />
                  <img src="/static/assets/images/one.png" width="86px" />
                  <div class="section-subtitle dark_subtitle">
                    No one in this world shall suffer from abuse or misuse of
                    cyberspace by another.
                  </div>
                  <img
                    src="/static/assets/images/two.png"
                    width="86px"
                    class="f-right"
                    style="margin-top: 10px"
                  />
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
            <div
              class="row hc-about-us-popular values hc-pb"
              style="padding-bottom: 10px"
            >
              <div class="col-sm-12">
                <div class="title-subtile-holder container">
                  <h1
                    class="section-title dark_title container"
                    style="font-size: 36px"
                  >
                    Our Values
                  </h1>
                  <br />
                  <p>
                    Our values are our guiding principles upon which we run our
                    business and make all our decisions.
                  </p>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
            <div class="row hc-about-us-popular values hc-pb">
              <div class="col-sm-12 col-md-12">
                <div class="container">
                  <h1 class="wow fadeIn no-margin">Truthfulness</h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Speaking honestly and openly with customers and other
                      stakeholders and taking care of their needs honestly.
                    </p>
                  </div>
                  <div class="clearfix"></div>
                  <div class="spacer_20"></div>
                  <br />
                  <br />
                  <div class="clearfix"></div>
                  <h1 class="wow fadeIn no-margin">Trust</h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Always ensuring top security for cyber contents submitted
                      by customers and maintaining confidentiality in all
                      business deals at the highest level.
                    </p>
                  </div>
                  <div class="clearfix"></div>
                  <div class="spacer_20"></div>
                  <br />
                  <br />
                  <div class="clearfix"></div>
                  <h1 class="wow fadeIn no-margin">Fairness</h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Adhering to ethical business practices, always have fair
                      agreements with customers and bear responsibility for
                      problems, rather than making excuses.
                    </p>
                  </div>
                  <div class="clearfix"></div>
                  <div class="spacer_20"></div>
                  <br />
                  <br />
                  <div class="clearfix"></div>
                  <h1 class="wow fadeIn no-margin">
                    Innovation &amp; Excellence
                  </h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Constantly striving for new technological inventions and
                      excellence assuring all innovations are productively used
                      to provide an excellent service to the customer.
                    </p>
                  </div>
                  <div class="clearfix"></div>
                  <div class="spacer_20"></div>
                  <br />
                  <br />
                  <div class="clearfix"></div>
                  <h1 class="wow fadeIn no-margin">Technology</h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Using the state of art Robust Eye Technology, the first
                      artificial intelligence-based technology available for
                      removal of contents entirely from all problem areas and
                      providing customers with the best possible service at an
                      affordable fee.
                    </p>
                  </div>
                  <div class="clearfix"></div>
                  <div class="spacer_20"></div>
                  <br />
                  <br />
                  <div class="clearfix"></div>
                  <h1 class="wow fadeIn no-margin">Cooperation</h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Maintaining a friendly relationship with customers,
                      ensuring that the customer is always provided with all
                      required information and technical support on time while
                      paying proper attention to the voice of customer.
                    </p>
                  </div>
                  <div class="clearfix"></div>
                  <div class="spacer_20"></div>
                  <br />
                  <br />
                  <div class="clearfix"></div>
                  <h1 class="wow fadeIn no-margin">Results Oriented</h1>
                  <div
                    class="wow fadeIn margin-top-bottom-30"
                    style="margin-bottom: 0px !important"
                  >
                    <p>
                      Always strive to provide the most appropriate solution to
                      the customer meeting the total requirements within the
                      time frame agreed upon.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- .entry-content -->
        </article>
      </main>
    </div>
  </div>
</template>

<script>
// /*---------------------------------------------*/
// /*--- 20. ANIMATION DOMAIN NAME ---------------*/
// /*---------------------------------------------*/
/* eslint-disable */
setTimeout(function () {
  //moving slider
  var scrollSpeed = 60; // Speed in milliseconds
  var step = 1; // How many pixels to move per step
  var current = 0; // The current pixel row
  var imageWidth = 3473; // Background image width
  var headerWidth = 1170; // How wide the header is.

  //The pixel row where to start a new loop
  var restartPosition = -(imageWidth - headerWidth);

  function scrollBg() {
    //Go to next pixel row.
    current += step;

    //If at the end of the image, then go to the top.
    if (current == restartPosition) {
      current = 0;
    }

    //Set the CSS of the header.
    // jQuery(".slider-moving").css("background-position", current + "px 0");
  }

  // setInterval(scrollBg, scrollSpeed);

  jQuery(".mt_typed_text_5b48675d69375").typed({
    strings: [
      "your content",
      "your data",
      "your brand",
      "your IP",
      "your reputation",
      "your privacy",
    ],
    typeSpeed: 0.1,
    backDelay: 3000,
    loop: true,
  });
});

export default {
  name: "personal_harassment",
  data() {
    return {
      msg: "Clear Me Out - Personal Cyber Harassments",
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.video-container {
  display: block;
  min-height: 40vw;
}
.bg-1,
.bg-2 {
  display: block;
  width: 100%;
  height: calc(40vw / 2);
}

.bg-1 {
  background: #fff;
}

.bg-2 {
  background: #6b67e4;
}
.vimeo-container {
  position: relative;
  min-height: 500px;
  overflow: hidden;
  padding: 0;
}
.vimeo-wrapper-test {
  display: block;
  position: absolute;
  top: 0%;
  left: calc((100vw - 50vw) / 2);
  margin: 0 auto;
  width: calc(50vw);
  height: 100%;
}
.vimeo-wrapper-test iframe {
  width: 100%;
  height: 100%; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */
  min-height: 100%;
  /* min-width: 177.77vh; Given a 16:9 aspect ratio, 16/9*100 = 177.77 */
  position: relative;
  top: 0%;
  left: 0%;
  /* transform: translate(-50%, -50%); */
}

.tooltip {
  position: relative;
  /* display: inline-block; */
  border-bottom: 1px dotted black;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 120px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 0.8em;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  bottom: 100%;
  left: 0;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}
</style>



// WEBPACK FOOTER //
// src/components/about.vue